import '@angular/compiler';
import { PageSettingsComponent } from './page.settings/page.settings.component';
import { PageAuditComponent } from './page.audit/page.audit.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageContentComparisonsComponent } from './page.content.comparisons/page.content.comparisons.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PagePatientsDetailComponent } from './page.patients.detail/page.patients.detail.component';
import { PageScenarioSetsComponent } from './page.scenario.sets/page.scenario.sets.component';
import { PagePromptsComponent } from './page.prompts/page.prompts.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { ComponentPatientCodeCopyComponent } from './component.patient.code.copy/component.patient.code.copy.component';
import { PageReferencesComponent } from './page.references/page.references.component';
import { PagePatientsComponent } from './page.patients/page.patients.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageContentComponent } from './page.content/page.content.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { PageAiUsageComponent } from './page.ai.usage/page.ai.usage.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageReviewComponent } from './page.review/page.review.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageSessionsComponent } from './page.sessions/page.sessions.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { ComponentContent_pricing_v2Component } from './component.content_pricing_v2/component.content_pricing_v2.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { ComponentSession_assets_v2Component } from './component.session_assets_v2/component.session_assets_v2.component';
import { ComponentWorkspaceHeaderComponent } from './component.workspace.header/component.workspace.header.component';
import { PageScheduleComponent } from './page.schedule/page.schedule.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { Injectable, NgModule } from '@angular/core';
import { CanDeactivate, RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "settings",
                component: PageSettingsComponent,
                "app_id": "page.settings"
            },
            {
                "path": "audit",
                component: PageAuditComponent,
                "app_id": "page.audit"
            },
            {
                "path": "content/comparisons",
                component: PageContentComparisonsComponent,
                "app_id": "page.content.comparisons"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "patients/:id",
                component: PagePatientsDetailComponent,
                "app_id": "page.patients.detail"
            },
            {
                "path": "scenario-sets",
                component: PageScenarioSetsComponent,
                "app_id": "page.scenario.sets"
            },
            {
                "path": "prompts",
                component: PagePromptsComponent,
                "app_id": "page.prompts"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "references",
                component: PageReferencesComponent,
                "app_id": "page.references"
            },
            {
                "path": "patients",
                component: PagePatientsComponent,
                "app_id": "page.patients"
            },
            {
                "path": "content",
                component: PageContentComponent,
                "app_id": "page.content"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "ai/usage",
                component: PageAiUsageComponent,
                "app_id": "page.ai.usage"
            },
            {
                "path": "review",
                component: PageReviewComponent,
                "app_id": "page.review"
            },
            {
                "path": "sessions",
                component: PageSessionsComponent,
                "app_id": "page.sessions"
            },
            {
                "path": "schedule",
                component: PageScheduleComponent,
                "app_id": "page.schedule"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            }
        ]
    },
    {
        component: LayoutAuthComponent,
        "children": [
            {
                "path": "signup",
                component: PageSignupComponent,
                "app_id": "page.signup"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

export interface PendingChangesAware {
    canDeactivate(): boolean | Promise<boolean>;
}

@Injectable({ providedIn: 'root' })
export class PendingChangesGuard implements CanDeactivate<PendingChangesAware> {
    public canDeactivate(component: PendingChangesAware | null): boolean | Promise<boolean> {
        if (!component || typeof component.canDeactivate !== 'function') return true;
        return component.canDeactivate();
    }
}

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component,
            canDeactivate: [PendingChangesGuard],
            // WIZ reuses a page component when only URL parameters change. Running
            // guards every time protects drafts when moving between patient IDs too.
            runGuardsAndResolvers: 'always'
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
